
import type { CoreTypes } from '../../core';
import type { Types as IdunSoftTypes } from '../types';
import _groups from './groups';
import _teachers from './teachers';
import _locations from './locations';
import _courses from './courses';
import _events from './events';
import type { InternalIdKey } from '../../core/types/common';

export namespace OutTypes {
  export type group    = Omit<CoreTypes.Serialized.Group,    InternalIdKey>;
  export type teacher  = Omit<CoreTypes.Serialized.Teacher,  InternalIdKey>;
  export type location = Omit<CoreTypes.Serialized.Location, InternalIdKey>;
  export type course   = Omit<CoreTypes.Serialized.Course,   InternalIdKey>;
  export type event    = Omit<CoreTypes.Serialized.Event,    InternalIdKey>;
};

type Out = {
  groups:    OutTypes.group[];
  teachers:  OutTypes.teacher[];
  locations: OutTypes.location[];
  courses:   OutTypes.course[];
  events:    OutTypes.event[];
};

export default function (schedule: Partial<IdunSoftTypes.schedule>): Out {
  return {
    groups:    _groups   (schedule['Grupp'  ] ?? []),
    teachers:  _teachers (schedule['Lärare' ] ?? []),
    locations: _locations(schedule['Rum'    ] ?? []),
    courses:   _courses  (schedule['Ämne'   ] ?? []),
    events:    _events   (schedule['Lektion'] ?? []),
  };
}